export const TITLE = "Altigreen Neev Price in 2026 - Range, Specification & Reviews | Turno";
export const H1_HEADING = "Altigreen Neev";
export const META_CONTENT = [
  {
    name: "description",
    content:
      "Looking for Altigreen Neev price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "keywords",
    content:
      "Altigreen Neev, Altigreen electric vehicle, Altigreen neEV, Altigreen electric cargo vehicle, Altigreen electric commercial vehicle, Altigreen Neev price, Altigreen Neev specifications, Altigreen Neev range, Altigreen Neev load capacity, Altigreen electric vehicle price, Altigreen commercial vehicle, Altigreen electric auto, Altigreen EV, Altigreen electric truck, Altigreen cargo vehicle, Altigreen electric vehicle specifications, Altigreen electric vehicle features, Altigreen electric vehicle reviews, Altigreen electric vehicle dealer",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content:
      "https://www.turno.club/electric-commercial-vehicles/Altigreen/neEV",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content:
      "https://www.turno.club/electric-commercial-vehicles/Altigreen/neEV",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Altigreen Neev Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    property: "og:description",
    content:
      "Looking for Altigreen Neev price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Looking for Altigreen Neev price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "twitter:title",
    content: "Altigreen Neev Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content:
      "https://www.turno.club/electric-commercial-vehicles/Altigreen/neEV",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK =
  "https://www.turno.club/electric-commercial-vehicles/Altigreen/neEV";

export const HIGHLIGHTS_HEADING = "Product Highlights";

export const SUB_TEXT =
  "The Altigreen neEV is set to redefine the market of electric commercial vehicles with its outstanding performance, stability, and remarkable load-carrying capacity of 550 kgs, making it the ultimate choice for businesses. With a robust torque of 45 Nm, an impressive 11 kWh motor, and a top speed designed for cargo transport, it guarantees efficient and dependable deliveries. Let's look into the key features and advantages of the Altigreen neEV:";

export const MOSTLY_BOUGHT_FOR_HEADING = "Mostly bought for";

export const BUSINESS_BENEFIT_HEADING =
  "Business Benefit with Electric Vehicle";

export const FEATURES_HEADING = "Features of Altigreen neEV";

export const BRAND_DEALER_HEADING = "Altigreen neEV Dealers Near Me: ";

export const BRAND_DEALER_DESCRIPITION =
  "Altigreen is expanding its presence across India, and we are excited to introduce the innovative Altigreen neEV to our community. As a trusted partner in sustainable transportation, we are dedicated to providing affordable and quality electric cargo vehicles.";

export const FAQ_HEADING_TEXT = "FAQs on Altigreen neEV";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Altigreen", href: "/electric-commercial-vehicles/Altigreen" },
  { label: "neEV" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Altigreen",
      item: "https://www.turno.club/electric-commercial-vehicles/Altigreen",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "neEV",
      item: VEHICLE_LINK,
    },
  ],
};
